import React from 'react';
// styles
import './home_styles.css';
// comps
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

const ProjectTemplate = function ({children}) {
    return (
        <div className={'home'}>
            <Header/>

            <div>
                {children}
            </div>

            <Footer/>
        </div>
    )
};

export default ProjectTemplate;


// WEBPACK FOOTER //
// ./src/components/templates/HomeTemplate.js